import { Button } from 'antd';
import GauQuiz from 'components/GauQuiz';
import React, { useEffect, useState } from 'react'

export default function GauQuizzes({ messages, questions, setQuestions, originQuestions, onDone }) {
    const [questionIndex, setQuestionIndex] = useState(0);
    const [buttonNext, setButtonNext] = useState(false);

    useEffect(() => {
        setQuestions(originQuestions.map((question, index) => ({
            ...question,
            onCorrect: (answerIndex) => {
                setButtonNext(true);
                setQuestions(questions => {
                    questions[index] = {
                        ...questions[index],
                        answerIndex: answerIndex,
                    }
                    return [...questions];
                })
            },
        })))
    }, [originQuestions]);
    const currentQuestion = questions[questionIndex];

    return <div style={{ position: "relative" }}>
        {currentQuestion && <GauQuiz
            question={currentQuestion}
            messages={messages}
        />
        }
        {
            buttonNext &&
            <Button type="primary" style={{
                position: "absolute",
                top: 30, right: 0,
            }} onClick={() => {
                setButtonNext(false);
                if (questionIndex < questions.length - 1) {
                    setQuestionIndex(questionIndex + 1);
                    return;
                }
                onDone && onDone.call();
            }}>
                {
                    questionIndex < questions.length - 1
                        ? <>Câu tiếp theo</>
                        : (onDone && onDone.button) || "Sang phần tiếp theo"
                }
            </Button>
        }
    </div>
}
